module.exports = __webpack_public_path__ + "assets/images/45dafc31ba5fb563f6dcd2f7241cac00.png";